export default __webpack_public_path__ + "images/55a18cafcdd9985adc32f4ab3ada9f51-perfil-financiero.svg";